import { Button, ComboBox, Dialog, DialogBody, DialogContent, DialogFooter, Label } from '@civilgrid/ui/components';
import type { ProjectManagerOption } from './useBulkActions';

export type ReassignDialogProps = {
  open: boolean;
  onClose: () => void;
  projectManagerId: string;
  onProjectManagerIdChange: (value: string) => void;
  projectManagerOptions: ProjectManagerOption[];
  onSubmit: () => void;
  isPending: boolean;
};

export function ReassignDialog({
  open,
  onClose,
  projectManagerId,
  onProjectManagerIdChange,
  projectManagerOptions,
  onSubmit,
  isPending,
}: ReassignDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent title="Reassign" preventDismiss data-testid="home-reassign-dialog" className="w-75">
        <DialogBody className="flex flex-col gap-2 w-full">
          <Label>Project Manager</Label>
          <ComboBox
            options={projectManagerOptions}
            value={projectManagerId}
            onValueChange={onProjectManagerIdChange}
            placeholder="Select a member"
            emptyText="No member found."
            searchPlaceholder="Search members..."
            triggerClassName="w-full"
            data-testid="home-reassign-dialog-combobox"
          />
        </DialogBody>
        <DialogFooter>
          <Button variant="secondary" onClick={onClose} data-testid="home-reassign-dialog-cancel">
            Cancel
          </Button>
          <Button
            onClick={onSubmit}
            disabled={isPending || !projectManagerId}
            data-testid="home-reassign-dialog-update"
          >
            {isPending ? 'Updating…' : 'Update'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
